import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import VisualizationPanel from "@/views/yewuAdmin/visualizationPanel/index.vue";
export default {
  name: "App",
  components: {
    VisualizationPanel: VisualizationPanel
  },
  computed: {
    isKanBan: function isKanBan() {
      return location.href.includes("visualizationPanel");
    }
  }
};